import ScreenWrapper from "@/components/ScreenWrapper"
import CreateOrganizationUserForm from "@/components/forms/organizationUser/CreateOrganizationUserForm"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/contactpersonen/aanmaken")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "contacts"),
})

function RouteComponent() {
  return (
    <ScreenWrapper className="mt-8" showManagementMenu>
      <CreateOrganizationUserForm />
    </ScreenWrapper>
  )
}
